exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Checkbox__root {\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.DS__Checkbox__checkbox {\n  margin-top: 2px;\n}\n\n.DS__Checkbox__text {\n  margin-left: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Checkbox__root",
	"checkbox": "DS__Checkbox__checkbox",
	"text": "DS__Checkbox__text"
};